import { createStorage } from '@/shared/lib/storage';

export interface ClipboardData<T = any> {
  readonly data: T;
  readonly timestamp: number;
}

const CLIPBOARD_KEY = 'clipboard';
const CLIPBOARD_EXPIRY_MS = 60 * 60 * 1000; // 1 hour

const storage = createStorage('app');

class ClipboardManager {
  private listeners: Set<(data: ClipboardData | null) => void> = new Set();

  async write(data: any): Promise<boolean> {
    const clipboardData: ClipboardData = {
      data,
      timestamp: Date.now(),
    };

    storage.set(CLIPBOARD_KEY, clipboardData);
    this.notifyListeners(clipboardData);
    return true;
  }

  read(): ClipboardData | null {
    return storage.get<ClipboardData>(CLIPBOARD_KEY, {
      expiryMs: CLIPBOARD_EXPIRY_MS,
    });
  }

  clear(): boolean {
    const success = storage.remove(CLIPBOARD_KEY);
    if (success) this.notifyListeners(null);
    return success;
  }

  subscribe(listener: (data: ClipboardData | null) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notifyListeners(data: ClipboardData | null): void {
    this.listeners.forEach((listener) => listener(data));
  }
}

export const clipboardManager = new ClipboardManager();
